import {Link} from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocument';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import ContactForm from '../components/contactform';
import Footer from '../components/footer';

function ContactView() {
  useDocumentTitle('Contact-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-4'} title={'Contact us'} link={'Contact'} />
      <ContactForm />
      <div className="ltn__call-to-action-area call-to-action-6 before-bg-bottom mt-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative text-center---">
                <div className="coll-to-info text-color-white">
                  <h1>
                    You can reach out to us today <br /> for all enquiries and
                    individual care needs.
                  </h1>
                </div>
                <div className="btn-wrapper">
                  <Link className="btn btn-effect-3 btn-white" to="/contact">
                    Request callback <i className="icon-next"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactView;
